import React from "react"

export const COLUMNS = [
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: 'Role',
    accessor: 'roles',
    // @ts-ignore
    Cell: ({ cell }) => {
      let rolesName = cell?.value?.map((item: any) => {
        return item
      })
      let str = rolesName?.join(', ')

      return <div>{str}</div>
    }
  },
  {
    Header: "Contact",
    accessor: "phoneNumber",
  },
  {
    Header: "Email",
    accessor: "email",
  },
  {
    Header: "",
    accessor: "add",
    Cell: ({ cell: { } }) => (
      <img
        className="eye-icon"
        src={"assets/images/addpatient.svg"}
        width={32}
        height={30}
        style={{
          marginTop: "6px",
          paddingRight: "15px",
          width: "40px",
          height: "40px",
        }}
        alt="eye"
      />
    ),
  },
]
